import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Save, Percent } from "lucide-react";

export function useDefaultMarkup(open = true) {
  const [mk, setMk] = useState(null);
  useEffect(() => {
    if (!open) return;
    api.get("/erp/settings").then(({ data }) => setMk(data.default_markup)).catch(() => setMk(null));
  }, [open]);
  return mk;
}

export const suggestPrice = (cost, mk) => (mk == null || !(Number(cost) > 0) ? "" : (Number(cost) * (1 + Number(mk) / 100)).toFixed(2));

export function DefaultMarkupCard() {
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/erp/settings").then(({ data }) => setVal(data.default_markup == null ? "" : String(data.default_markup))).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try {
      const v = val.trim() === "" ? null : Number(val.replace(",", "."));
      await api.patch("/erp/settings", { default_markup: v });
      toast.success("Markup padrão salvo");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="default-markup-card" className="rounded-xl border border-zinc-800 bg-zinc-950/70 p-5 md:p-7">
      <div className="flex items-center gap-2 mb-4"><Percent className="h-4 w-4 text-amber-brand" /><h2 className="font-display text-lg font-bold uppercase text-zinc-100">Markup padrão das peças</h2></div>
      <p className="text-sm text-zinc-400 mb-3">Usado para sugerir o preço de venda de peças novas (cadastro manual ou compra por XML): preço = custo × (1 + markup). Você pode editar o preço. Peças já cadastradas não mudam.</p>
      <div className="flex items-end gap-3 flex-wrap">
        <div className="w-40">
          <Label className="text-xs font-mono-caps text-zinc-400">Markup (%)</Label>
          <Input data-testid="default-markup-input" value={val} onChange={(e) => setVal(e.target.value.replace(/[^0-9.,]/g, ""))} inputMode="decimal" placeholder="ex.: 100" className="mt-1 bg-zinc-900 border-zinc-800 text-base sm:text-sm" />
        </div>
        <Button data-testid="default-markup-save" onClick={save} disabled={busy} className="h-10 bg-green-brand hover:bg-green-brandDark text-white font-bold uppercase">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : (<><Save className="h-4 w-4 mr-2" /> Salvar markup</>)}
        </Button>
      </div>
      {val !== "" && <p data-testid="default-markup-example" className="text-xs text-zinc-500 mt-2">Exemplo: custo R$ 20,00 → venda sugerida R$ {(20 * (1 + Number(val.replace(",", ".")) / 100)).toFixed(2).replace(".", ",")}</p>}
    </div>
  );
}
